import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoadingService } from "../loading.service";

export function loadingInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {

    console.log(request.urlWithParams);

    const loadingService = inject(LoadingService);

    if (!request.url.includes('/api/calculadora/consulta')) loadingService.counter++;

    if (!request.url.includes('/api/calculadora/consulta')) loadingService.loadingOn();

    return next(request).pipe(finalize(() => {
        if (!request.url.includes('/api/calculadora/consulta')) loadingService.counter--;
        if (loadingService.counter == 0) {
            if (!request.url.includes('/api/calculadora/consulta')) loadingService.loadingOff();
        }
    }));

}